<input class="mat-input-element" [matDatepicker]="DatePicker" placeholder="Choose a date" [(ngModel)]="date" #DateModel="ngModel" (ngModelChange)="calculateValue()" (blur)="onTouched()">
<mat-datepicker-toggle matSuffix [for]="DatePicker"></mat-datepicker-toggle>
<mat-datepicker #DatePicker></mat-datepicker>
<input type="time" class="mat-input-element" [(ngModel)]="time" #TimeModel="ngModel" (ngModelChange)="calculateValue()" (blur)="onTouched()">
